import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/hurst-logo-white-background.svg")